import { api } from './api';
import { ApiPath } from '../api/ApiPath';

export function getTemporaryToken(): Promise<string> {
  return api<{ token: string }>({ url: ApiPath.AuthTemporaryToken }).then(({ token }) => token);
}
